import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/fhq-invitation-settings';
import { ResultState } from '@rootCommon/types/common';
import { FhqInvitation } from '@rootCommon/types/fhq';

type Action = ActionType<typeof actions>;
export type FhqInvitationState = ResultState<FhqInvitation[] | null>;

const initState: FhqInvitationState = {
  data: null,
  loading: false,
  error: null,
};

export const fhqInvitationSettingsReducer = (state = initState, action: Action): FhqInvitationState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchFhqInvitationSettings.request):
      return { ...state, loading: true };
    case getType(actions.fetchFhqInvitationSettings.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchFhqInvitationSettings.failure):
      return { ...state, loading: false, error: action.payload };

      // update
    case getType(actions.updateFhqInvitationSettings.request):
      return { ...state, loading: true };
    case getType(actions.updateFhqInvitationSettings.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.updateFhqInvitationSettings.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default fhqInvitationSettingsReducer;
